export default function MenuTemplate(els) {
    els.forEach(el => {
        el.querySelector('.gb-button-cta-featured-primary').addEventListener(
            'click',
            () => {
                localStorage.setItem(
                    'clickedMenuTemplateAsset',
                    el.dataset.menuTemplateAssetUrl
                );
            }
        );
    });
}

const hideLightbox = () => {
    const lightbox = document.querySelector('.js-leadform-lightbox-wrapper');
    if (lightbox) lightbox.style.display = 'none';
    document.body.classList.remove('js-show-lightbox');
};

const replaceButtonHrefWithAssetLink = menuTemplate => {
    const menuTemplateButton = menuTemplate.querySelector('a');
    if (menuTemplateButton)
        menuTemplateButton.href = menuTemplate.dataset.menuTemplateAssetUrl;
};

const replaceUrlWithAssetLink = assetUrl => {
    window.location.replace(assetUrl);
};

export function replaceAllMenuTemplateAssetUrlsAndDownload() {
    hideLightbox();
    const assetUrl = localStorage.getItem('clickedMenuTemplateAsset');
    if (assetUrl) {
        document.querySelectorAll('.menu-template').forEach(menuTemplate => {
            replaceButtonHrefWithAssetLink(menuTemplate);
        });
        replaceUrlWithAssetLink(assetUrl);
    }
}
